import { createPageSchema as e, opaqueCursorSchema as t, pageLimitSchema as n } from "../common/index.js";
import { roleSchema as r, userSummarySchema as i } from "./base.js";
import { membershipPageSchema as a } from "../teams/index.js";
import { z as o } from "zod";
// src/identity/access.ts
var s = o.object({
	role: r,
	expectedVersion: o.number().int().positive()
}).strip(), c = e(i), l = i.extend({ membershipCount: o.number().int().nonnegative() }), u = e(l), d = o.object({
	user: l,
	memberships: a
}).strict(), f = o.object({
	query: o.string().max(100).optional(),
	role: o.enum([
		"none",
		"Agent",
		"Admin"
	]).optional(),
	corporateState: o.enum(["active", "deactivated"]).optional(),
	teamId: o.string().uuid().optional(),
	corporateIdentityId: o.string().uuid().optional(),
	contactReady: o.stringbool().optional(),
	cursor: t.optional(),
	limit: n
}).strip(), p = o.object({
	includeEnded: o.stringbool().optional(),
	cursor: t.optional(),
	limit: n
}).strip();
export { s as changeRoleSchema, d as userDirectoryDetailSchema, u as userDirectoryPageSchema, l as userDirectorySummarySchema, f as userListQuerySchema, p as userMembershipListQuerySchema, c as userPageSchema };

//# sourceMappingURL=access.js.map